<template>
  <!-- Top progress bar — zobrazí se při navigaci mezi stránkami -->
  <div class="page-loader-bar" :class="{ 'page-loader-bar--active': active, 'page-loader-bar--done': done }"></div>
</template>

<script>
import { loadingState } from '../loading.js';

export default {
  data() {
    return {
      active: false, // probíhá navigace
      done: false,   // navigace dokončena — spustí fade-out
      timer: null,
      doneTimer: null,
    };
  },

  watch: {
    // Reagujeme na změnu globálního stavu loaderu
    'loadingState.active'(val) {
      if (val) {
        this.start();
      } else {
        this.finish();
      }
    },
  },

  created() {
    // Přímá reference na reaktivní objekt pro watch
    this.loadingState = loadingState;
  },

  methods: {
    start() {
      // Zrušíme případný předchozí timer dokončení
      clearTimeout(this.doneTimer);
      this.done = false;
      this.active = true;
    },

    finish() {
      // Krátká prodleva, aby bar doběhl na 100 % vizuálně
      this.doneTimer = setTimeout(() => {
        this.done = true;
        // Po fade-outu skryjeme bar úplně
        setTimeout(() => {
          this.active = false;
          this.done = false;
        }, 400);
      }, 150);
    },
  },
};
</script>